import React from 'react';
import RetailIntro from '../components/RetailIntro/RetailIntro';
import CtaSection from '../components/CtaSection/CtaSection'; // Import CTA

const RetailPage = () => {
  return (
    <>
      <RetailIntro />
      <CtaSection />
    </>
  );
};

export default RetailPage;
